import React, { useState, useMemo } from 'react';
import config from './config.js'


// --- SVG Icon Components ---
// Using inline SVGs to keep everything in one file and avoid external dependencies.

const MenuIcon = ({ className }) => (
    <svg className={className} stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
        <line x1="3" y1="12" x2="21" y2="12"></line>
        <line x1="3" y1="6" x2="21" y2="6"></line>
        <line x1="3" y1="18" x2="21" y2="18"></line>
    </svg>
);

const CloseIcon = ({ className }) => (
    <svg className={className} stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
);

const ChevronDownIcon = ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
    </svg>
);

const ShoppingCartIcon = ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"></path></svg>
);

const PlusIcon = ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path></svg>
);

const MinusIcon = ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 12H4"></path></svg>
);

const TrashIcon = ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
);

const WhatsAppIcon = ({ className }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.05 4.91A9.816 9.816 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.73-1.11-5.22-2.91-7.01zm-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.264 8.264 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24 2.2 0 4.23.86 5.82 2.45s2.45 3.62 2.45 5.82c0 4.54-3.7 8.24-8.24 8.24zm4.52-6.16c-.25-.12-1.47-.72-1.7-.82s-.39-.12-.56.12c-.17.25-.64.82-.79.99-.14.17-.29.19-.54.06s-1.05-.39-2-1.23c-.74-.66-1.23-1.47-1.38-1.72s-.03-.38.11-.51c.13-.13.29-.33.43-.49.14-.14.19-.25.29-.41.09-.17.05-.31-.01-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.42h-.48c-.17 0-.43.06-.66.31-.22.25-.86.85-.86 2.07s.88 2.4 1 2.56c.12.17 1.76 2.67 4.25 3.73.59.25 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.15-1.18s-.22-.16-.47-.28z" />
    </svg>
);

const PhoneIcon = ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
    </svg>
);


// --- Image Configuration ---
// Central location for all image paths. Makes updating images much easier.
// Replace these placeholder paths with your actual image paths in the /public/images/ folder.
const imagePaths = {
    logo: "/images/logo.png",
    hero: "/images/banner.png",
    mondayLunch: "/images/RajmaThali.png",
    mondayDinner: "/images/MixVeg.png",
    tuesdayLunch: "/images/alooGobhi.png",
    tuesdayDinner: "/images/paneer.png",
    wednesdayLunch: "/images/chholeBhatture.png",
    wednesdayDinner: "/images/bhindiFry.png",
    thursdayLunch: "/images/DalMakhani.png",
    thursdayDinner: "/images/matarPaneer.png",
    fridayLunch: "/images/seasonalVeg.png",
    fridayDinner: "/images/Pulao.png",
    saturdayLunch: "/images/pavBhaji.png",
    saturdayDinner: "/images/alooMatar.png",
};


// --- Component Definitions ---

const Header = ({ cartCount, isMenuOpen, setIsMenuOpen, openOrderModal, setIsCartModalOpen }) => {
    return (
        <header className="bg-white/80 backdrop-blur-md shadow-md sticky top-0 z-50">
            <div className="container mx-auto px-6 py-4 flex justify-between items-center">
                <a href="#" className="flex items-center">
                    <img src={imagePaths.logo} alt="Desi Meal Logo" className="h-16 md:h-20" />
                </a>
                <nav className="hidden md:flex space-x-8 items-center">
                    <a href="#menu" className="text-gray-700 hover:text-amber-600 transition-colors">Our Menu</a>
                    <a href="#pricing" className="text-gray-700 hover:text-amber-600 transition-colors">Plans</a>
                    <a href="#testimonials" className="text-gray-700 hover:text-amber-600 transition-colors">Testimonials</a>
                    <a href="#faq" className="text-gray-700 hover:text-amber-600 transition-colors">FAQ</a>
                    <button onClick={() => openOrderModal()} className="bg-amber-500 text-white font-semibold px-5 py-2 rounded-full hover:bg-amber-600 transition-all shadow-sm">Order Plan</button>
                    <button onClick={() => setIsCartModalOpen(true)} className="relative text-gray-700 hover:text-amber-600 transition-colors">
                        <ShoppingCartIcon className="w-7 h-7" />
                        {cartCount > 0 && <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">{cartCount}</span>}
                    </button>
                </nav>
                <div className="md:hidden flex items-center gap-4">
                    <button onClick={() => setIsCartModalOpen(true)} className="relative text-gray-700 hover:text-amber-600 transition-colors">
                        <ShoppingCartIcon className="w-7 h-7" />
                        {cartCount > 0 && <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">{cartCount}</span>}
                    </button>
                    <button onClick={() => setIsMenuOpen(!isMenuOpen)}>
                        {isMenuOpen ? <CloseIcon className="w-7 h-7 text-gray-700" /> : <MenuIcon className="w-7 h-7 text-gray-700" />}
                    </button>
                </div>
            </div>
            {/* Mobile Menu */}
            <div className={`md:hidden ${isMenuOpen ? 'block' : 'hidden'} bg-white absolute w-full shadow-lg`}>
                <a href="#menu" className="block text-center py-3 px-4 text-gray-700 hover:bg-amber-50" onClick={() => setIsMenuOpen(false)}>Our Menu</a>
                <a href="#pricing" className="block text-center py-3 px-4 text-gray-700 hover:bg-amber-50" onClick={() => setIsMenuOpen(false)}>Pricing</a>
                <a href="#testimonials" className="block text-center py-3 px-4 text-gray-700 hover:bg-amber-50" onClick={() => setIsMenuOpen(false)}>Testimonials</a>
                <a href="#faq" className="block text-center py-3 px-4 text-gray-700 hover:bg-amber-50" onClick={() => setIsMenuOpen(false)}>FAQ</a>
                <div className="p-4">
                    <button onClick={openOrderModal} className="w-full text-center block bg-amber-500 text-white font-semibold px-5 py-3 rounded-full hover:bg-amber-600 transition-all shadow-sm">Order a Plan</button>
                </div>
            </div>
        </header>
    );
};

const HeroSection = () => (
    <section className="relative h-[60vh] md:h-[80vh] bg-cover bg-center text-white flex items-center justify-center" style={{ backgroundImage: `url('${imagePaths.hero}')` }}>
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="relative z-10 text-center px-4">
            <h2 className="text-4xl md:text-6xl font-extrabold tracking-tight mb-4 leading-tight">
                Authentic Homemade Meals,
                <br />
                <span className="text-amber-400">Delivered to Your Doorstep.</span>
            </h2>
            <p className="text-lg md:text-xl max-w-2xl mx-auto mb-8 text-gray-200">
                Enjoy healthy, hygienic, and delicious tiffin service across Mumbai. Made with fresh ingredients and lots of love.
            </p>
            <a href="#pricing" className="bg-amber-500 text-white font-bold text-lg px-8 py-4 rounded-full hover:bg-amber-600 transition-transform transform hover:scale-105 shadow-lg">
                View Tiffin Plans
            </a>
        </div>
    </section>
);

const HowItWorks = () => (
    <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6 text-center">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">How It Works</h3>
            <p className="text-gray-600 mb-12 max-w-2xl mx-auto">Getting fresh, homemade food is as easy as 1-2-3!</p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
                <div className="flex flex-col items-center">
                    <div className="bg-amber-500 text-white w-20 h-20 rounded-full flex items-center justify-center text-3xl font-bold mb-4 shadow-lg">1</div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">Choose Your Meal</h4>
                    <p className="text-gray-600">Select a subscription plan or order a full thali from our daily menu.</p>
                </div>
                <div className="flex flex-col items-center">
                    <div className="bg-amber-500 text-white w-20 h-20 rounded-full flex items-center justify-center text-3xl font-bold mb-4 shadow-lg">2</div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">We Prepare With Care</h4>
                    <p className="text-gray-600">Our expert chefs cook your meals fresh every day using high-quality ingredients.</p>
                </div>
                <div className="flex flex-col items-center">
                    <div className="bg-amber-500 text-white w-20 h-20 rounded-full flex items-center justify-center text-3xl font-bold mb-4 shadow-lg">3</div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">Enjoy Timely Delivery</h4>
                    <p className="text-gray-600">Your delicious tiffin is delivered straight to your home or office, right on time.</p>
                </div>
            </div>
        </div>
    </section>
);

// const MenuSection = ({ weeklyMenu, selectedDay, setSelectedDay, handleAddToCart }) => (
//     <section id="menu" className="py-20 bg-white">
//         <div className="container mx-auto px-6">
//             <h3 className="text-3xl md:text-4xl font-bold text-gray-800 text-center mb-12">This Week's Tiffin Menu</h3>
//             <div className="flex justify-center flex-wrap gap-2 md:gap-4 mb-8">
//                 {Object.keys(weeklyMenu).map(day => (
//                     <button
//                         key={day}
//                         onClick={() => setSelectedDay(day)}
//                         className={`px-4 py-2 text-sm md:text-base font-semibold rounded-full transition-all duration-300 ${selectedDay === day ? 'bg-amber-500 text-white shadow-md' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
//                     >
//                         {day}
//                     </button>
//                 ))}
//             </div>
//             <div className="bg-amber-50 p-6 md:p-10 rounded-2xl shadow-inner max-w-4xl mx-auto">
//                 {weeklyMenu[selectedDay] ? (
//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//                         {/* Lunch Thali */}
//                         <div className="flex flex-col bg-white rounded-xl shadow-md p-4">
//                             <img src={weeklyMenu[selectedDay].lunch.image} alt="Lunch Meal" className="w-full h-48 object-cover rounded-lg shadow-sm mb-4" />
//                             <h4 className="text-2xl font-bold text-amber-700 mb-3">Lunch</h4>
//                             <ul className="space-y-2 text-gray-700 mb-4 flex-grow">
//                                 {weeklyMenu[selectedDay].lunch.items.map((item, i) => (
//                                     <li key={i} className="flex items-center"><span className="text-amber-500 mr-2">✓</span>{item}</li>
//                                 ))}
//                             </ul>
//                             <div className="flex justify-between items-center mt-4">
//                                 <span className="font-bold text-xl text-amber-600">₹{weeklyMenu[selectedDay].lunch.price}</span>
//                                 <button onClick={() => handleAddToCart(weeklyMenu[selectedDay].lunch)} className="bg-amber-500 text-white font-semibold px-5 py-2 rounded-full hover:bg-amber-600 transition-all text-sm shadow-sm">
//                                     Order Thali
//                                 </button>
//                             </div>
//                         </div>
//                         {/* Dinner Thali */}
//                         <div className="flex flex-col bg-white rounded-xl shadow-md p-4">
//                             <img src={weeklyMenu[selectedDay].dinner.image} alt="Dinner Meal" className="w-full h-48 object-cover rounded-lg shadow-sm mb-4" />
//                             <h4 className="text-2xl font-bold text-amber-700 mb-3">Dinner</h4>
//                             <ul className="space-y-2 text-gray-700 mb-4 flex-grow">
//                                 {weeklyMenu[selectedDay].dinner.items.map((item, i) => (
//                                     <li key={i} className="flex items-center"><span className="text-amber-500 mr-2">✓</span>{item}</li>
//                                 ))}
//                             </ul>
//                             <div className="flex justify-between items-center mt-4">
//                                 <span className="font-bold text-xl text-amber-600">₹{weeklyMenu[selectedDay].dinner.price}</span>
//                                 <button onClick={() => handleAddToCart(weeklyMenu[selectedDay].dinner)} className="bg-amber-500 text-white font-semibold px-5 py-2 rounded-full hover:bg-amber-600 transition-all text-sm shadow-sm">
//                                     Order Thali
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 ) : (
//                     <div className="text-center text-gray-600 py-8">
//                         <p className="text-xl font-semibold">Sunday is our day off!</p>
//                         <p>Our chefs are resting to bring you more delicious meals next week.</p>
//                     </div>
//                 )}
//             </div>
//         </div>
//     </section>
// );

const MenuSection = ({ menuData, handleAddToCart }) => (
    <section id="menu" className="py-20 bg-white">
        <div className="container mx-auto px-6">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-800 text-center mb-12">Our Tiffin Menu</h3>
            {/* Removed day selection buttons */}
            <div className="bg-amber-50 p-6 md:p-10 rounded-2xl shadow-inner max-w-6xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {/* Lunch Thali */}
                    <div className="flex flex-col bg-white rounded-xl shadow-md p-4">
                        <img src={menuData.lunch.image} alt="Basic Meal" className="w-full h-48 object-cover rounded-lg shadow-sm mb-4" />
                        <h4 className="text-2xl font-bold text-amber-700 mb-3">Basic Meal</h4>
                        <ul className="space-y-2 text-gray-700 mb-4 flex-grow">
                            {menuData.basic.items.map((item, i) => (
                                <li key={i} className="flex items-center"><span className="text-amber-500 mr-2">✓</span>{item}</li>
                            ))}
                        </ul>
                        <div className="flex justify-between items-center mt-4">
                            <span className="font-bold text-xl text-amber-600">₹{menuData.basic.price}</span>
                            <button onClick={() => handleAddToCart(menuData.basic)} className="bg-amber-500 text-white font-semibold px-5 py-2 rounded-full hover:bg-amber-600 transition-all text-sm shadow-sm">
                                Order Meal
                            </button>
                        </div>
                    </div>
                    {/* Dinner Thali */}
                    <div className="flex flex-col bg-white rounded-xl shadow-md p-4">
                       <img src={menuData.full.image} alt="Full Meal" className="w-full h-48 object-cover rounded-lg shadow-sm mb-4" />
                       <h4 className="text-2xl font-bold text-amber-700 mb-3">Full Meal</h4>
                        <ul className="space-y-2 text-gray-700 mb-4 flex-grow">
                            {menuData.full.items.map((item, i) => (
                                <li key={i} className="flex items-center"><span className="text-amber-500 mr-2">✓</span>{item}</li>
                            ))}
                        </ul>
                        <div className="flex justify-between items-center mt-4">
                            <span className="font-bold text-xl text-amber-600">₹{menuData.full.price}</span>
                            <button onClick={() => handleAddToCart(menuData.full)} className="bg-amber-500 text-white font-semibold px-5 py-2 rounded-full hover:bg-amber-600 transition-all text-sm shadow-sm">
                                Order Meal
                            </button>
                        </div>
                    </div>
                    {/* Premium Thali */}
                    <div className="flex flex-col bg-white rounded-xl shadow-md p-4">
                       <img src={menuData.premium.image} alt="Premium Meal" className="w-full h-48 object-cover rounded-lg shadow-sm mb-4" />
                       <h4 className="text-2xl font-bold text-amber-700 mb-3">Premium Meal</h4>
                        <ul className="space-y-2 text-gray-700 mb-4 flex-grow">
                            {menuData.premium.items.map((item, i) => (
                                <li key={i} className="flex items-center"><span className="text-amber-500 mr-2">✓</span>{item}</li>
                            ))}
                        </ul>
                        <div className="flex justify-between items-center mt-4">
                            <span className="font-bold text-xl text-amber-600">₹{menuData.premium.price}</span>
                            <button onClick={() => handleAddToCart(menuData.premium)} className="bg-amber-500 text-white font-semibold px-5 py-2 rounded-full hover:bg-amber-600 transition-all text-sm shadow-sm">
                                Order Meal
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

const PricingSection = ({ pricingPlans, openOrderModal }) => (
    <section id="pricing" className="py-20 bg-gray-50">
        <div className="container mx-auto px-6 text-center">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Our Tiffin Plans</h3>
            <p className="text-gray-600 mb-12 max-w-2xl mx-auto">Simple, affordable, and transparent pricing for our subscription plans.</p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
                {pricingPlans.map(plan => (
                    <div key={plan.name} className={`bg-white rounded-2xl p-8 shadow-lg transition-transform transform hover:-translate-y-2 relative flex flex-col ${plan.popular ? 'border-4 border-amber-500' : ''}`}>
                        {plan.popular && <div className="absolute top-0 -translate-y-1/2 left-1/2 -translate-x-1/2 bg-amber-500 text-white text-xs font-bold px-4 py-1 rounded-full uppercase">Most Popular</div>}
                        <h4 className="text-2xl font-bold text-gray-800 mb-2">{plan.name}</h4>
                        <div className="mb-6 flex items-baseline justify-center gap-2">
                            <span className="text-4xl font-extrabold text-amber-600">{plan.price}</span>
                            {plan.originalPrice && (
                                <span className="text-xl font-medium text-gray-500 line-through">{plan.originalPrice}</span>
                            )}
                        </div>
                        <ul className="space-y-3 text-gray-600 mb-8 text-left flex-grow">
                            {plan.features.map(feature => (
                                <li key={feature} className="flex items-center">
                                    <span className="text-green-500 mr-3">✔</span> {feature}
                                </li>
                            ))}
                        </ul>
                        <button onClick={() => openOrderModal(plan.name)} className={`w-full mt-auto block text-center font-bold py-3 px-6 rounded-lg transition-all ${plan.popular ? 'bg-amber-500 text-white hover:bg-amber-600' : 'bg-gray-200 text-gray-800 hover:bg-gray-300'}`}>
                            Subscribe Now
                        </button>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

const TestimonialsSection = ({ testimonials }) => (
    <section id="testimonials" className="py-20 bg-white">
        <div className="container mx-auto px-6 text-center">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-800 mb-12">What Our Customers Say</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {testimonials.map((testimonial, i) => (
                    <div key={i} className="bg-amber-50 p-8 rounded-xl shadow-md">
                        <p className="text-gray-600 italic mb-6">"{testimonial.quote}"</p>
                        <div className="font-bold text-amber-800">{testimonial.name}</div>
                        <div className="text-sm text-gray-500">{testimonial.role}</div>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

const FaqSection = ({ faqs, openFaqIndex, handleFaqToggle }) => (
    <section id="faq" className="py-20 bg-gray-50">
        <div className="container mx-auto px-6 max-w-3xl">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-800 text-center mb-12">Frequently Asked Questions</h3>
            <div className="space-y-4">
                {faqs.map((faq, index) => (
                    <div key={index} className="bg-white rounded-lg shadow-sm overflow-hidden">
                        <button onClick={() => handleFaqToggle(index)} className="w-full text-left p-6 flex justify-between items-center focus:outline-none">
                            <span className="text-lg font-semibold text-gray-800">{faq.q}</span>
                            <ChevronDownIcon className={`w-6 h-6 text-amber-500 transition-transform duration-300 ${openFaqIndex === index ? 'rotate-180' : ''}`} />
                        </button>
                        <div className={`transition-all duration-300 ease-in-out overflow-hidden ${openFaqIndex === index ? 'max-h-96' : 'max-h-0'}`}>
                            <p className="p-6 pt-0 text-gray-600">{faq.a}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

const OrderSection = () => (
    <section id="order" className="py-20 bg-amber-500 text-white">
        <div className="container mx-auto px-6 text-center">
            <h3 className="text-3xl md:text-4xl font-bold mb-4">Ready to Enjoy Delicious Home-Cooked Food?</h3>
            <p className="text-amber-100 text-lg mb-8 max-w-2xl mx-auto">Start your subscription or place an order today!</p>
            <a href="#menu" className="bg-white text-amber-600 font-bold text-lg px-8 py-4 rounded-full hover:bg-amber-50 transition-transform transform hover:scale-105 shadow-lg inline-block">
                Order Now
            </a>
        </div>
    </section>
);

const Footer = () => (
    <footer className="bg-gray-800 text-gray-300">
        <div className="container mx-auto px-6 py-12">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                <div>
                    <h4 className="text-xl font-bold text-white mb-4">Desi Meals</h4>
                    <p className="text-gray-400">Your daily dose of delicious, home-cooked food in Mumbai.</p>
                </div>
                <div>
                    <h5 className="font-semibold text-white mb-4">Quick Links</h5>
                    <ul className="space-y-2">
                        <li><a href="#menu" className="hover:text-amber-400 transition-colors">Menu</a></li>
                        <li><a href="#pricing" className="hover:text-amber-400 transition-colors">Pricing</a></li>
                        <li><a href="#testimonials" className="hover:text-amber-400 transition-colors">Testimonials</a></li>
                        <li><a href="#faq" className="hover:text-amber-400 transition-colors">FAQ</a></li>
                    </ul>
                </div>
                <div>
                    <h5 className="font-semibold text-white mb-4">Contact Us</h5>
                    <ul className="space-y-2 text-gray-400">
                        <li>Email: care.desimeal@gmail.com</li>
                        <li>Phone: +91 9167551616</li>
                        <li>Mumbai, Maharashtra</li>
                    </ul>
                </div>
                <div>
                    <h5 className="font-semibold text-white mb-4">Follow Us</h5>
                    <div className="flex space-x-4">
                        <a href="#" className="hover:text-amber-400 transition-colors">Facebook</a>
                        <a href="#" className="hover:text-amber-400 transition-colors">Instagram</a>
                    </div>
                </div>
            </div>
        </div>
        <div className="bg-gray-900 py-4 text-center text-gray-500 text-sm">
            <p>&copy; {new Date().getFullYear()} Desi Meals. All Rights Reserved.</p>
        </div>
    </footer>
);

const OrderModal = ({ isOrderModalOpen, setIsOrderModalOpen, cart, setCart, cartTotal, selectedPlan, pricingPlans }) => {
    const [formData, setFormData] = useState({ name: '', phone: '', address: '', pincode: '', plan: 'Monthly Plan' });
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitError, setSubmitError] = useState(null);
    const [mealSelection, setMealSelection] = useState('Both');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleMealChange = (value) => {
        setMealSelection(value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitError(null);

        const submissionData = { ...formData };
        if (cart.length > 0) {
            submissionData['Order Details'] = cart.map(item => `${item.quantity} x ${item.name} (₹${item.price})`).join(', ');
            submissionData['Total Bill'] = `₹${cartTotal}`;
        } else {
            submissionData['Order Details'] = `Subscription for: ${selectedPlan} (${mealSelection})`;
            const plan = pricingPlans.find(p => p.name === selectedPlan);
            if (plan) {
                submissionData['Total Bill'] = plan.price;
            }
        }

        const formSubmitUrl = `https://formsubmit.co/ajax/${config.formSubmitEmail}`;
        const googleScriptUrl = config.googleSheetUrl;

        fetch(googleScriptUrl, {
            method: 'POST',
            mode: 'no-cors',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(submissionData)
        }).catch(error => {
            // Log the error for debugging, but don't show it to the user
            // as this operation is not critical for the user flow.
            console.error("Google Sheet submission error (background):", error);
        });

        // The main logic now only waits for the email submission.
        fetch(formSubmitUrl, {
            method: "POST",
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
                ...submissionData,
                _subject: "New Tiffin Order from Desi Meals Website!",
                _captcha: "false"
            })
        })
        .then(async (response) => {
            if (!response.ok) {
                // If FormSubmit fails, we consider the whole submission failed
                throw new Error('Email submission failed. Please try again.');
            }
            const data = await response.json();
            console.log("FormSubmit Success:", data);
            
            setIsSubmitted(true);
            setCart([]); // Clear cart only on successful submission
        })
        .catch(error => {
            console.error("Submission Error:", error);
            setSubmitError(error.message || "There was an error submitting your order. Please try again.");
        })
        .finally(() => {
            setIsSubmitting(false);
        });
    };

    if (!isOrderModalOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg relative max-h-[90vh] overflow-y-auto">
                <button onClick={() => setIsOrderModalOpen(false)} className="absolute top-4 right-4 text-gray-500 hover:text-gray-800">
                    <CloseIcon className="w-7 h-7" />
                </button>
                {isSubmitted ? (
                    <div className="p-8 md:p-12 text-center">
                        <h3 className="text-2xl font-bold text-green-600 mb-4">Thank You!</h3>
                        <p className="text-gray-700 mb-2">Your order request has been received.</p>
                        <p className="text-gray-700">We will call you shortly to confirm the details.</p>
                        <button onClick={() => { setIsSubmitted(false); setIsOrderModalOpen(false); }} className="mt-6 bg-amber-500 text-white font-semibold px-6 py-2 rounded-full hover:bg-amber-600 transition-all shadow-sm">Close</button>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="p-8 md:p-12">
                        <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 text-center">Confirm Your Details</h3>
                        {submitError && <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4" role="alert">{submitError}</div>}
                        <div className="space-y-5">
                            <div>
                                <label htmlFor="name" className="font-semibold text-gray-700 block mb-1">Full Name</label>
                                <input type="text" name="name" id="name" required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-400 focus:border-amber-400 transition" placeholder="e.g., Priya Sharma" onChange={handleChange} value={formData.name} />
                            </div>
                            <div>
                                <label htmlFor="phone" className="font-semibold text-gray-700 block mb-1">Phone Number <span className="text-red-500">*</span></label>
                                <input 
                                    type="tel" 
                                    name="phone" 
                                    id="phone" 
                                    required 
                                    pattern="[0-9]{10}" 
                                    title="Please enter a 10-digit mobile number" 
                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-400 focus:border-amber-400 transition" 
                                    placeholder="10-digit mobile number" 
                                    onChange={handleChange} 
                                    value={formData.phone} 
                                />
                            </div>
                            <div>
                                <label htmlFor="address" className="font-semibold text-gray-700 block mb-1">Delivery Address</label>
                                <textarea name="address" id="address" required rows="3" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-400 focus:border-amber-400 transition" placeholder="Full address" onChange={handleChange} value={formData.address}></textarea>
                            </div>
                            <div>
                                <label htmlFor="pincode" className="font-semibold text-gray-700 block mb-1">Pincode</label>
                                <input type="text" name="pincode" id="pincode" required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-400 focus:border-amber-400 transition" placeholder="e.g., 400001" onChange={handleChange} value={formData.pincode} />
                            </div>
                            {cart.length === 0 && (
                                <div>
                                    <span className="font-semibold text-gray-700 block mb-2">Selected Plan: <span className="font-bold text-amber-600">{selectedPlan}</span></span>
                                    <label className="font-semibold text-gray-700 block mb-2">Meal Preference:</label>
                                    <div className="grid grid-cols-3 gap-2 rounded-lg p-1 bg-gray-200">
                                        <button type="button" onClick={() => handleMealChange('Lunch')} className={`w-full py-2 text-sm font-semibold rounded-md transition-colors ${mealSelection === 'Lunch' ? 'bg-amber-500 text-white shadow' : 'bg-white text-gray-700'}`}>Lunch</button>
                                        <button type="button" onClick={() => handleMealChange('Dinner')} className={`w-full py-2 text-sm font-semibold rounded-md transition-colors ${mealSelection === 'Dinner' ? 'bg-amber-500 text-white shadow' : 'bg-white text-gray-700'}`}>Dinner</button>
                                        <button type="button" onClick={() => handleMealChange('Both')} className={`w-full py-2 text-sm font-semibold rounded-md transition-colors ${mealSelection === 'Both' ? 'bg-amber-500 text-white shadow' : 'bg-white text-gray-700'}`}>Both</button>
                                    </div>
                                </div>
                            )}
                        </div>
                        <button type="submit" disabled={isSubmitting} className="w-full mt-8 bg-amber-500 text-white font-bold py-3 px-6 rounded-lg hover:bg-amber-600 transition-all text-lg shadow-md disabled:bg-gray-400 disabled:cursor-not-allowed">
                            {isSubmitting ? 'Submitting...' : 'Submit Request'}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
};

const CartModal = ({ isCartModalOpen, setIsCartModalOpen, cart, cartTotal, handleQuantityChange, handleRemoveFromCart, openOrderModal }) => {
    if (!isCartModalOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg relative max-h-[90vh] flex flex-col">
                <div className="p-6 flex justify-between items-center border-b">
                    <h3 className="text-2xl font-bold text-gray-800">Your Cart</h3>
                    <button onClick={() => setIsCartModalOpen(false)} className="text-gray-500 hover:text-gray-800">
                        <CloseIcon className="w-7 h-7" />
                    </button>
                </div>

                {cart.length === 0 ? (
                    <div className="p-8 text-center text-gray-600">
                        <p>Your cart is empty.</p>
                    </div>
                ) : (
                    <>
                        <div className="p-6 overflow-y-auto flex-grow">
                            <div className="space-y-4">
                                {cart.map(item => (
                                    <div key={item.id} className="flex items-center justify-between gap-4">
                                        <img src={item.image} alt={item.name} className="w-16 h-16 rounded-md object-cover" />
                                        <div className="flex-grow">
                                            <p className="font-semibold text-gray-800">{item.name}</p>
                                            <p className="text-sm text-gray-600">₹{item.price}</p>
                                        </div>
                                        <div className="flex items-center gap-2">
                                            <button onClick={() => handleQuantityChange(item.id, -1)} className="p-1 rounded-full bg-gray-200 hover:bg-gray-300"><MinusIcon className="w-4 h-4" /></button>
                                            <span className="w-8 text-center font-semibold">{item.quantity}</span>
                                            <button onClick={() => handleQuantityChange(item.id, 1)} className="p-1 rounded-full bg-gray-200 hover:bg-gray-300"><PlusIcon className="w-4 h-4" /></button>
                                        </div>
                                        <button onClick={() => handleRemoveFromCart(item.id)} className="text-red-500 hover:text-red-700"><TrashIcon className="w-5 h-5" /></button>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="p-6 border-t mt-auto">
                            <div className="flex justify-between items-center font-bold text-xl mb-4">
                                <span>Total:</span>
                                <span>₹{cartTotal}</span>
                            </div>
                            <button onClick={openOrderModal} className="w-full bg-amber-500 text-white font-bold py-3 px-6 rounded-lg hover:bg-amber-600 transition-all text-lg shadow-md">
                                Proceed to Checkout
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

// --- NEW COMPONENT: Floating Action Buttons ---
const FloatingActionButtons = () => {
    // Construct the correct URLs from the config
    const whatsappUrl = `https://wa.me/91${config.whatsappNumber}?text=${encodeURIComponent("Hello Desi Meals! I'd like to know more about your tiffin service.")}`;
    const callUrl = `tel:+91${config.callNumber}`;

    return (
        <div className="fixed bottom-5 right-5 z-50 flex flex-col items-center gap-3">
            <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center text-white shadow-lg transform transition-transform hover:scale-110"
                aria-label="Chat on WhatsApp"
            >
                <WhatsAppIcon className="w-8 h-8" />
            </a>
            <a
                href={callUrl}
                className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center text-white shadow-lg transform transition-transform hover:scale-110"
                aria-label="Call Now"
            >
                <PhoneIcon className="w-7 h-7" />
            </a>
        </div>
    );
};

// --- Main App Component ---
export default function App() {
    // --- Data Definitions ---
    const weeklyMenuData = {
        Monday: {
            lunch: { id: 'mon-lunch', name: "Monday Lunch Thali", price: 120, items: ["Rajma Masala", "Jeera Rice", "4 Chapatis", "Boondi Raita", "Salad"], image: imagePaths.mondayLunch },
            dinner: { id: 'mon-dinner', name: "Monday Dinner Thali", price: 120, items: ["Mixed Veg Curry", "Dal Tadka", "4 Chapatis", "Steamed Rice", "Salad"], image: imagePaths.mondayDinner }
        },
        Tuesday: {
            lunch: { id: 'tue-lunch', name: "Tuesday Lunch Thali", price: 120, items: ["Aloo Gobi", "Dal Fry", "4 Chapatis", "Steamed Rice", "Salad"], image: imagePaths.tuesdayLunch },
            dinner: { id: 'tue-dinner', name: "Tuesday Dinner Thali", price: 120, items: ["Paneer Butter Masala", "Jeera Rice", "4 Chapatis", "Cucumber Raita", "Salad"], image: imagePaths.tuesdayDinner }
        },
        Wednesday: {
            lunch: { id: 'wed-lunch', name: "Wednesday Lunch Special", price: 120, items: ["Chole Bhature (2 Pcs)", "Onion Salad", "Pickle"], image: imagePaths.wednesdayLunch },
            dinner: { id: 'wed-dinner', name: "Wednesday Dinner Thali", price: 120, items: ["Kadhi Pakora", "Steamed Rice", "Bhindi Fry", "4 Chapatis", "Salad"], image: imagePaths.wednesdayDinner }
        },
        Thursday: {
            lunch: { id: 'thu-lunch', name: "Thursday Lunch Thali", price: 120, items: ["Dal Makhani", "Jeera Rice", "4 Chapatis", "Mixed Veg Raita", "Salad"], image: imagePaths.thursdayLunch },
            dinner: { id: 'thu-dinner', name: "Thursday Dinner Thali", price: 120, items: ["Matar Paneer", "Steamed Rice", "4 Chapatis", "Salad"], image: imagePaths.thursdayDinner }
        },
        Friday: {
            lunch: { id: 'fri-lunch', name: "Friday Lunch Thali", price: 120, items: ["Seasonal Veg Curry", "Yellow Dal", "4 Chapatis", "Steamed Rice", "Salad"], image: imagePaths.fridayLunch },
            dinner: { id: 'fri-dinner', name: "Friday Dinner Special", price: 120, items: ["Veg Pulao", "Cucumber Raita", "Papad", "Special Sweet Dish"], image: imagePaths.fridayDinner }
        },
        Saturday: {
            lunch: { id: 'sat-lunch', name: "Saturday Lunch Special", price: 120, items: ["Pav Bhaji (4 Pcs Pav)", "Grated Cheese", "Chopped Onions"], image: imagePaths.saturdayLunch },
            dinner: { id: 'sat-dinner', name: "Saturday Dinner Thali", price: 120, items: ["Aloo Matar", "Dal Palak", "4 Chapatis", "Steamed Rice", "Salad"], image: imagePaths.saturdayDinner }
        }
    };
    const fixedMenuData = {
        lunch: { id: 'lunch-thali', name: "Lunch Thali", price: 120, items: ["Sabzi of the Day", "Dal of the Day", "Steamed Rice/ Jeera Rice", "4 Chapatis", "Salad", "Pickle"], image: imagePaths.mondayLunch },
        dinner: { id: 'dinner-thali', name: "Dinner Thali", price: 120, items: ["Sabzi of the Day", "Dal of the Day", "Steamed Rice", "4 Chapatis", "Salad", "Pickle"], image: imagePaths.mondayDinner },
        basic: { id: 'basic-thali', name: "Basic Meal", price: 110, items: ["4 Chapatis", "Sabzi of the Day", "Salad", "Sweet Dish (Friday)"], image: imagePaths.mondayLunch },
        premium: { id: 'premium-thali', name: "Premium Meal", price: 170, items: ["3 Chapatis", "2 Sabzi of the Day", "Dal of the Day", "Rice", "Salad", "Sweet Dish (Friday)"], image: imagePaths.mondayDinner},
        full: { id: 'full-thali', name: "Full Meal", price: 140, items: ["3 Chapatis", "Sabzi of the Day", "Dal of the Day", "Rice", "Salad", "Sweet Dish (Friday)"], image: imagePaths.fridayLunch }
    };
    // const pricingPlansData = [
    //     { name: "Weekly Plan", price: "₹570", originalPrice: "600", popular: false, features: ["5 Days of Meals", "One meal per day", "Flexible Pausing", "Standard Menu", "Unique meals daily"] },
    //     { name: "Monthly Plan", price: "₹2400", originalPrice: "2600", popular: true, features: ["22 Days of Meals", "One meal per day", "Flexible Pausing", "Unique meals daily - no menu repeats within the week.", "Priority Support"] },
    //     { name: "Trial Plan", price: "₹600", popular: false, features: ["3 Days of Meals", "One meal per day", "Taste Our Quality"] }
    // ];
    const pricingPlansData = [
        { name: "Basic Meal Plan", price: "₹1980", originalPrice: "2200", popular: false, features: ["20 Days of Meals", "One meal per day", "Flexible Pausing", "Menu: 4 Chapatis, 1 Sabzi, Salad, Sweet(Friday)", "Unique meals daily"] },
        { name: "Full Meal Plan", price: "₹2520", originalPrice: "2800", popular: true, features: ["20 Days of Meals", "One meal per day", "Flexible Pausing", "Menu: 3 Chapatis, 1 Sabzi, Rice, Dal, Salad, Sweet(Friday)", "Unique meals daily", "Priority Support"] },
        { name: "Premium Meal Plan", price: "₹3060", originalPrice: "3400", popular: false, features: ["20 Days of Meals", "One meal per day", "Flexible Pausing", "Menu: 3 Chapatis, 2 Sabzi, Rice, Dal, Salad, Sweet(Friday)", "Unique meals daily", "Priority Support"] }
    ];
    const testimonialsData = [
        { quote: "Desi Meals is a lifesaver! The food tastes just like home and the delivery is always on time. Highly recommend for any busy professional in Mumbai.", name: "Priya Sharma", role: "Software Engineer" },
        { quote: "I've tried many tiffin services, but the quality and variety from Desi Meals are unmatched. The monthly plan is great value for money.", name: "Rohan Mehta", role: "Marketing Manager" },
        { quote: "As a student, getting healthy, home-cooked food was a challenge. Thanks to Desi Meals, I get delicious and hygienic meals every day.", name: "Anjali Singh", role: "University Student" }
    ];
    const faqsData = [
        { q: "What areas in Mumbai do you deliver to?", a: "We currently deliver to most areas in South Mumbai, Central Suburbs, and Western Suburbs. Please enter your pincode on the order page to confirm availability in your area." },
        { q: "Can I customize my meals?", a: "While we have a set weekly menu to ensure quality and efficiency, we do offer options to exclude certain ingredients for allergies. Please contact our support team for specific requests." },
        { q: "What are the delivery timings?", a: "Lunch is typically delivered between 12:00 PM and 1:30 PM, and dinner is delivered between 7:00 PM and 8:30 PM." },
        { q: "How does the subscription pause feature work?", a: "You can pause your subscription through your online account. For the monthly plan, you can pause up to 2 times. Please inform us at least 24 hours in advance." }
    ];

    // --- State Management ---
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [selectedDay, setSelectedDay] = useState('Monday');
    const [openFaqIndex, setOpenFaqIndex] = useState(null);
    const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
    const [isCartModalOpen, setIsCartModalOpen] = useState(false);
    const [cart, setCart] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState('Monthly Plan');

    // --- Event Handlers ---
    const handleFaqToggle = (index) => {
        setOpenFaqIndex(openFaqIndex === index ? null : index);
    };

    const openOrderModal = (planName) => {
        if (planName) {
            setSelectedPlan(planName);
        } else if (cart.length === 0) {
            setSelectedPlan('Monthly Plan'); // Default if opening form directly without plan selection
        }
        setIsMenuOpen(false);
        setIsCartModalOpen(false);
        setIsOrderModalOpen(true);
    };

    const handleAddToCart = (item) => {
        setCart(prevCart => {
            const existingItem = prevCart.find(cartItem => cartItem.id === item.id);
            if (existingItem) {
                return prevCart.map(cartItem =>
                    cartItem.id === item.id ? { ...cartItem, quantity: cartItem.quantity + 1 } : cartItem
                );
            }
            return [...prevCart, { ...item, quantity: 1 }];
        });
        setIsCartModalOpen(true);
    };

    const handleQuantityChange = (itemId, amount) => {
        setCart(prevCart => {
            return prevCart.map(item => {
                if (item.id === itemId) {
                    const newQuantity = item.quantity + amount;
                    return newQuantity > 0 ? { ...item, quantity: newQuantity } : null;
                }
                return item;
            }).filter(Boolean);
        });
    };

    const handleRemoveFromCart = (itemId) => {
        setCart(prevCart => prevCart.filter(item => item.id !== itemId));
    };

    const cartCount = useMemo(() => cart.reduce((count, item) => count + item.quantity, 0), [cart]);
    const cartTotal = useMemo(() => cart.reduce((total, item) => total + item.price * item.quantity, 0), [cart]);

    // --- Render ---
    return (
        <div className="bg-white font-sans">
            <Header
                cartCount={cartCount}
                isMenuOpen={isMenuOpen}
                setIsMenuOpen={setIsMenuOpen}
                openOrderModal={openOrderModal}
                setIsCartModalOpen={setIsCartModalOpen}
            />
            <main>
                <HeroSection />
                <HowItWorks />
                {/* 
                <MenuSection
                    weeklyMenu={weeklyMenuData}
                    selectedDay={selectedDay}
                    setSelectedDay={setSelectedDay}
                    handleAddToCart={handleAddToCart}
                />
                */}
                <MenuSection 
                    menuData={fixedMenuData} // Use fixed menu data
                    handleAddToCart={handleAddToCart}
                />
                <PricingSection
                    pricingPlans={pricingPlansData}
                    openOrderModal={openOrderModal}
                />
                <TestimonialsSection testimonials={testimonialsData} />
                <FaqSection
                    faqs={faqsData}
                    openFaqIndex={openFaqIndex}
                    handleFaqToggle={handleFaqToggle}
                />
                <OrderSection />
            </main>
            <Footer />
            <OrderModal
                isOrderModalOpen={isOrderModalOpen}
                setIsOrderModalOpen={setIsOrderModalOpen}
                cart={cart}
                setCart={setCart}
                cartTotal={cartTotal}
                pricingPlans={pricingPlansData}
                selectedPlan={selectedPlan}
            />
            <CartModal
                isCartModalOpen={isCartModalOpen}
                setIsCartModalOpen={setIsCartModalOpen}
                cart={cart}
                cartTotal={cartTotal}
                handleQuantityChange={handleQuantityChange}
                handleRemoveFromCart={handleRemoveFromCart}
                openOrderModal={openOrderModal}
            />

            <FloatingActionButtons />
        </div>
    );
}
